import { 
  FETCHING_EXHIBITION_MEETINGS_USERS_REQUEST,
  FETCHING_EXHIBITION_MEETINGS_USERS_SUCCESS,
  FETCHING_EXHIBITION_MEETINGS_USERS_FAILURE,

  UPDATE_EXHIBITION_MEETINGS_USER_REQUEST,
  UPDATE_EXHIBITION_MEETINGS_USER_SUCCESS,
  UPDATE_EXHIBITION_MEETINGS_USER_FAILURE,

  CREATE_EXHIBITION_MEETINGS_USER_REQUEST,
  CREATE_EXHIBITION_MEETINGS_USER_SUCCESS,
  CREATE_EXHIBITION_MEETINGS_USER_FAILURE,

  DELETE_EXHIBITION_MEETINGS_USER_REQUEST,
  DELETE_EXHIBITION_MEETINGS_USER_SUCCESS,
  DELETE_EXHIBITION_MEETINGS_USER_FAILURE,
} from "../actions/types";

import ResponseService from '../../utils/ResponseService';
import ApplicationError from '../../utils/ApplicationError';

const initialState = {
  meetingsUsers: [],
  meetingsUser: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData()
};

const meetingsUsersReducer = (state = initialState, action ) => {
  switch(action.type) {

    // Get MeetingsUsers
    case FETCHING_EXHIBITION_MEETINGS_USERS_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_EXHIBITION_MEETINGS_USERS_SUCCESS:
      return {...state, isFetching: false, 
        meetingsUsers: action.payload.objects, 
        error: ApplicationError.buildDefault(),
        ...action.payload.paginationData }
        
    case FETCHING_EXHIBITION_MEETINGS_USERS_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    // Create
    case  CREATE_EXHIBITION_MEETINGS_USER_REQUEST:
      return {...state, isFetching: true }
    case  CREATE_EXHIBITION_MEETINGS_USER_SUCCESS:
      return {...state, isFetching: false, meetingsUser: action.payload, error: ApplicationError.buildDefault() }
    case  CREATE_EXHIBITION_MEETINGS_USER_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    // Update
    case  UPDATE_EXHIBITION_MEETINGS_USER_REQUEST:
      return {...state, isFetching: true }
    case  UPDATE_EXHIBITION_MEETINGS_USER_SUCCESS:
      return {...state, isFetching: false, meetingsUser: action.payload, error: ApplicationError.buildDefault() }
    case  UPDATE_EXHIBITION_MEETINGS_USER_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    // Delete  
    case  DELETE_EXHIBITION_MEETINGS_USER_REQUEST:
      return {...state, isFetching: true }
    case  DELETE_EXHIBITION_MEETINGS_USER_SUCCESS:
      return {...state, isFetching: false, error: ApplicationError.buildDefault() }
    case  DELETE_EXHIBITION_MEETINGS_USER_FAILURE:
      return {...state, isFetching: false, error: action.payload }


    default: 
      return state
  }
}

export default meetingsUsersReducer